//round
import round1 from '../assets/images/cakes-shape/round1.png';
import round2 from '../assets/images/cakes-shape/round2.png';
import round3 from '../assets/images/cakes-shape/round3.png';

//rectangular
import rectangular1 from '../assets/images/cakes-shape/rectangular1.png';
import rectangular2 from '../assets/images/cakes-shape/rectangular2.png';
import rectangular3 from '../assets/images/cakes-shape/rectangular3.png';

//spange
import spangeRed from '../assets/images/cake-spange/spange-red.jpg';
import spangeBrown from '../assets/images/cake-spange/spange-brown.jpg';
import spangeYellow from '../assets/images/cake-spange/spange-yellow.jpg';

//icing
import icingBlue from '../assets/images/cake-icing/icing-blue.png';
import icingRed from '../assets/images/cake-icing/icing-red.png';
import icingYellow from '../assets/images/cake-icing/icing-yellow.png';
import icingGreen from '../assets/images/cake-icing/icing-green.png';
import icingOrange from '../assets/images/cake-icing/icing-orange.png';
import icingGray from '../assets/images/cake-icing/icing-gray.png';

//filling
import fillingPurple from '../assets/images/cake-filling/filling-purple.png';
import fillingBrown from '../assets/images/cake-filling/filling-brown.png';
import fillingPink from '../assets/images/cake-filling/filling-pink.png';
import fillingWhite from '../assets/images/cake-filling/filling-white.png';

export const IMAGES = {
    round1,
    round2,
    round3,
    rectangular1,
    rectangular2,
    rectangular3,
    spangeRed,
    spangeBrown,
    spangeYellow,
    icingBlue,
    icingRed,
    icingYellow,
    icingGreen,
    icingOrange,
    icingGray,
    fillingPurple,
    fillingBrown,
    fillingPink,
    fillingWhite,
}